module.exports = __webpack_public_path__ + "img/indicador-1.2b05acef.svg";